import React, { useState, useEffect, useRef, useContext } from "react";
import Request from "../../core/httpClient";
import cogoToast from "cogo-toast";
import { Helmet } from "react-helmet";
import Sidebar from "../header/sidebar";
import Header from "../header/header";
import { Context } from "../../context";
import SidebarOperacion from "../header/sidebarOperacion";
const request = new Request();

const BloqcatCrud = () => {
  const { fracActual } = useContext(Context);

  const [bloqcats, setBloqcats] = useState([]);
  const [categories, setCategories] = useState([]);
  const [idCategoria, setIdCategoria] = useState("");
  const [maximoPermitidos, setMaximoPermitidos] = useState("");
  const [editId, setEditId] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);

  const inputRef = useRef(null);

  // Leer configuraciones
  const getBloqcats = async () => {
    const data = { id: fracActual };
    const response = await request.post("/commonArea/bloqcat/get", data);
    if (!response.error && response.bloqcats) {
      setBloqcats(response.bloqcats);
    }
  };

  // Leer categorías disponibles
  const getCategories = async () => {
    const data = { id: fracActual };
    const response = await request.post("/commonArea/get/categories", data);
    if (!response.error && response.categories) {
      setCategories(response.categories);
    }
  };

  useEffect(() => {
    getBloqcats();
    getCategories();
  }, []);

  useEffect(() => {
    if (fracActual) {
      getBloqcats();
      getCategories();
    }
  }, [fracActual]);

  // Crear nuevo registro
  const handleCreate = async (e) => {
    e.preventDefault();
    const data = {
      id_categoria: parseInt(idCategoria, 10),
      id_fraccionamiento: fracActual,
      maximo_permitidos: parseInt(maximoPermitidos, 10),
    };
    const response = await request.post("/commonArea/create/bloqcat", data);
    if (!response.error) {
      cogoToast.success("Categoría añadida al subfraccionamiento");
      setIdCategoria("");
      setMaximoPermitidos("");
      setShowCreateForm(false);
      getBloqcats();
    }
  };

  // Actualizar existente
  const handleUpdate = async (e) => {
    e.preventDefault();
    const data = {
      IdFraccionamiento: fracActual,
      maximo_permitidos: parseInt(maximoPermitidos, 10),
    };
    const response = await request.put(`/commonArea/bloqcat/update/${editId}`, data);
    if (response.updated) {
      cogoToast.success("Máximo permitido actualizado");
    }
    setMaximoPermitidos("");
    setEditId(null);
    getBloqcats();
  };

  const handleEdit = (bloq) => {
    setMaximoPermitidos(bloq.maximo_permitidos);
    setEditId(bloq.id_bloqueo);
    setShowCreateForm(false); // oculta el de crear si entras a editar
  };

  const handleDelete = async (id) => {
    const response = await request.delete(`/commonArea/bloqcat/delete/${id}`);
    if (response.deleted) {
      cogoToast.success("Configuración eliminada");
      getBloqcats();
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>{process.env.REACT_APP_NAME} - Configuración Categorías</title>
      </Helmet>
      <Header

        sidebar={true}
        active="activas"
        parent="areas"
        panel="panel3"
        nav="operacion"
      // menu={menu}
      />

      <div className="flex flex-1">
        <div id="sidebar" style={{ width: "220px", borderRight: "1px solid #ddd" }}>
          <SidebarOperacion />
        </div>

        <main className="flex-1 p-6">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center mb-4">
              <button
                onClick={() => {
                  setShowCreateForm(true);
                  setEditId(null);
                }}
                className="btn-purple"
              >
                Crear nueva categoría
              </button>
            </div>

            {/* Tabla */}
            <table className="w-full border border-gray-200 rounded-lg shadow-sm mb-8">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-200 px-4 py-2 text-center">Categoría</th>
                  <th className="border border-gray-200 px-4 py-2 text-center">Máximo Permitidos</th>
                  <th className="border border-gray-200 px-4 py-2 text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {bloqcats.map((bloq) => (
                  <tr key={bloq.id_bloqueo} className="hover:bg-gray-50">
                    <td className="border border-gray-200 px-4 py-2 text-center">{bloq.nombre_categoria}</td>
                    <td className="border border-gray-200 px-4 py-2 text-center">{bloq.maximo_permitidos}</td>
                    <td className="border border-gray-200 px-4 py-2 text-center">
                      <button
                        onClick={() => handleEdit(bloq)}
                        className="btn-purple inline-flex items-center gap-2 px-3 py-2 mr-2"
                      >
                        <i className="fas fa-pen"></i>
                        Editar
                      </button>
                      <button
                        onClick={() => handleDelete(bloq.id_bloqueo)}
                        className="btn-red inline-flex items-center gap-2 px-3 py-2"
                      >
                        <i className="fas fa-trash"></i>
                        Eliminar
                      </button>
                    </td>


                  </tr>
                ))}
              </tbody>
            </table>

            {/* Formulario de creación */}
            {showCreateForm && !editId && (
              <div className="mb-6">
                <h3 className="text-lg font-semibold mb-3">Crear nueva categoría</h3>
                <form onSubmit={handleCreate} className="space-y-4">
                  <select
                    value={idCategoria}
                    onChange={(e) => setIdCategoria(e.target.value)}
                    required
                    className="input-edit-select-full"
                  >
                    <option value="">Selecciona una categoría</option>
                    {categories.map((cat) => (
                      <option key={cat.id_categoria} value={cat.id_categoria}>
                        {cat.nombre}
                      </option>
                    ))}
                  </select>

                  <input
                    type="number"
                    placeholder="Máximo Permitidos"
                    value={maximoPermitidos}
                    onChange={(e) => setMaximoPermitidos(e.target.value)}
                    required
                    className="input-user"
                  />

                  <button type="submit" className="btn-purple">
                    Crear categoría en subfraccionamiento
                  </button>
                </form>
              </div>
            )}

            {/* Formulario de actualización */}
            {editId && (
              <div className="mb-6">
                <h3 className="text-lg font-semibold mb-3">Actualizar categoría</h3>
                <form onSubmit={handleUpdate} className="space-y-4">
                  <input
                    type="number"
                    placeholder="Máximo Permitidos"
                    value={maximoPermitidos}
                    onChange={(e) => setMaximoPermitidos(e.target.value)}
                    required
                    className="input-edit"
                  />
                  <button type="submit" className="btn-purple">
                    Actualizar
                  </button>
                </form>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );

};

export default BloqcatCrud;
